import singleP from "../_ApiConn/apiSinglePage";


const getSinglePageById = async (idToGet) => {
    let dFromF = await singleP.getSinglePageById(idToGet);
    return (dFromF.data);
}

const getPageByName = async (name) => {
    let dFromF = await singleP.getPageByName(name);
    return (dFromF.data[0]);
}

const allPgsNames = async () => {
    let dFromF = await singleP.allPgsNames();
    return (dFromF.data);
}

export default {
    getSinglePageById,
    getPageByName,
    allPgsNames
};